import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import JobSignoff from './JobSignoff';
import { getTechniciansByAreaId } from 'selectors/technicianSelectors';
import { jobSignoffForm } from 'constants/FormConstants';
import moment from 'moment';

const JobSignoffContainer = () => {
  const dispatch = useDispatch();

  const currentJob = useSelector((state) => state.currentJob);
  const signoffDate = moment().toISOString();
  const technicians = useSelector((state) => getTechniciansByAreaId(state));
  const formValues = useSelector((state) => getFormValues(jobSignoffForm)(state));

  return (
    <JobSignoff
      clientDetails={useSelector((state) => state.clientDetails)}
      currentJob={currentJob}
      currentState={currentJob.currentState}
      referenceData={useSelector((state) => state.referenceData)}
      supervisorSignoff={currentJob.supervisorSignoff || {}}
      initialValues={{
        signoffDate,
        complete: true,
      }}
      technicians={technicians}
      formValues={formValues}
      changeFieldValue={(field, value) => dispatch(change(jobSignoffForm, field, value))}
    />
  );
};

export default JobSignoffContainer;
